/**
 * Таблица дочерних событий для BatchEventPage
 * Переиспользуемый компонент с возможностью выполнения событий
 */
import React from 'react';
import { Table, Button, Space } from 'antd';
import type { BatchChildEvent } from '../../../types/plantingEvents';
import { EventStatusTag } from './EventStatusTag';
import { EventLocationCell } from './EventLocationCell';
import { formatEventDate } from '../utils/eventFormatters';

interface BatchEventTableProps {
  events: BatchChildEvent[];
  loading?: boolean;
  onCompleteEvent: (event: BatchChildEvent) => void;
  canCompleteEvents: boolean;
  selectedEventIds?: string[];
  onSelectionChange?: (selectedIds: string[]) => void;
}

export const BatchEventTable: React.FC<BatchEventTableProps> = ({
  events,
  loading,
  onCompleteEvent,
  canCompleteEvents,
  selectedEventIds = [],
  onSelectionChange,
}) => {
  const columns = [
    {
      title: '#',
      dataIndex: 'batchSequence',
      key: 'batchSequence',
      width: 60,
      render: (num: number) => `#${num}`,
    },
    {
      title: 'Локация',
      key: 'location',
      render: (record: BatchChildEvent) => (
        <EventLocationCell event={record} showTargetType={false} />
      ),
    },
    {
      title: 'Тип цели',
      key: 'targetType',
      width: 120,
      render: (record: BatchChildEvent) => (
        <EventLocationCell event={{ ...record }} showTargetType={true} />
      ),
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      width: 140,
      render: (status: any) => <EventStatusTag status={status} />,
    },
    {
      title: 'Фактическая дата',
      dataIndex: 'actualDate',
      key: 'actualDate',
      width: 140,
      render: (date: string | null) => formatEventDate(date),
    },
    {
      title: 'Действия',
      key: 'actions',
      width: 120,
      render: (record: BatchChildEvent) => (
        <Space>
          {canCompleteEvents &&
            (record.status === 'planned' ||
              record.status === 'pending' ||
              record.status === 'in_progress') && (
              <Button type="primary" size="small" onClick={() => onCompleteEvent(record)}>
                Выполнить
              </Button>
            )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={events}
      columns={columns}
      rowKey="id"
      loading={loading}
      pagination={false}
      locale={{ emptyText: 'Нет дочерних событий' }}
      rowSelection={
        onSelectionChange
          ? {
              selectedRowKeys: selectedEventIds,
              onChange: (selectedRowKeys) => {
                onSelectionChange(selectedRowKeys as string[]);
              },
              getCheckboxProps: (record) => ({
                disabled:
                  record.status === 'completed' || record.status === 'cancelled',
              }),
            }
          : undefined
      }
    />
  );
};
